<!-- <ng-container *ngIf="relipayConfig.layout.style === 'relipay-distributer-template'">
  <relipay-template></relipay-template>
</ng-container> -->
<!-- <app-testing></app-testing> -->
<ng-container *ngIf="isShow">
  <router-outlet></router-outlet>
  <app-ticketing *ngIf="_UserService.loginData && _UserService.loginData.is_ticket"></app-ticketing>
  <app-loader></app-loader>
</ng-container>